@if (initDone) {
    <router-outlet></router-outlet>
}
@if (!isProduction) {
    <div (click)="simulate()" class="simulation">SIMULATE</div>
}

@if (isLoading$ | async) {
    <div class="progress-spinner">
        <p-progressSpinner></p-progressSpinner>
    </div>
}

@if (!initDone && !apiAvailable) {
    <div class="page-center">
        <div class="box items-center text-center">
            <p-progressSpinner></p-progressSpinner>
            <p class="mt-4">The timeBuzzer API is currently not available.<br />This page will load as soon as the API is back online.</p>
        </div>
    </div>
}

<!-- App-wide confirmation dialog. The message template renders what PrimeNG renders by default (icon and message)
     plus the optional warning of an AppConfirmation. -->
<p-confirmDialog>
    <ng-template #message let-confirmation>
        <div class="flex flex-col gap-4">
            <div class="flex items-center gap-4">
                @if (confirmation.icon) {
                    <i class="p-confirmdialog-icon" [ngClass]="confirmation.icon"></i>
                }
                <span class="p-confirmdialog-message" [innerHTML]="confirmation.message"></span>
            </div>
            <!-- 'warning' is our own custom AppConfirmation field; PrimeNG does not render it -->
            @if (confirmation.warning) {
                <p-message severity="warn" data-testid="confirmation-warning">{{ confirmation.warning }}</p-message>
            }
        </div>
    </ng-template>
</p-confirmDialog>

<p-toast position="top-right"></p-toast>

<p-toast key="withHtml" position="top-right">
    <!-- Note: This toast template is aligned with the PrimeNg V20 p-toast default template -->
    <!-- Remember that toasts with different keys are created in different containers and do no stack properly! -->
    <ng-template let-message pTemplate="template">
        <!-- pTemplate="template" is inside container: <div class="p-toast-message-content"> -->
        @switch (message.severity) {
            @case ("success") {
                <i class="pi pi-check-circle p-toast-message-icon p-icon"></i>
            }
            @case ("error") {
                <i class="pi pi-times-circle p-toast-message-icon p-icon"></i>
            }
            @case ("warn") {
                <i class="pi pi-exclamation-triangle p-toast-message-icon p-icon"></i>
            }
            @default {
                <i class="pi pi-info-circle p-toast-message-icon p-icon"></i>
            }
        }
        <div class="p-toast-message-text">
            <div class="p-toast-summary">{{ message.summary | translate }}</div>
            <div class="p-toast-detail" [innerHTML]="message.detail | safe: 'html'"></div>
        </div>
    </ng-template>
</p-toast>
